import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as BestFriendIcon } from '../../assets/images/appicons/appicon-best-friends.svg';
import { ReactComponent as EmptyFriend } from '../../assets/images/empty-friend.svg';
import { Photo } from '../shared/Photo';
import { WaveCover } from '../shared/WaveCover';

export const BestFriendsEmpty = () => {
  const { t } = useTranslation('best_friends');
  return (
    <div
      className={css`
        color: #4d3906;
        height: 100%;
        font-size: 14px;
        text-align: center;

        .heading {
          display: flex;
          justify-content: center;
          align-items: center;
          border-top: 2px dashed #dcd8bf;
          border-bottom: 2px dashed #dcd8bf;
          padding: 16px;
          margin: 40px auto 0;
          h2 {
            margin-left: 16px;
          }
        }
        h2 {
          font-size: 16px;
        }
        p {
          font-size: 14px;
        }
        section {
          padding: 0 32px 64px;
        }
        .content {
          max-width: 480px;
          margin: 0 auto;
        }
        section:nth-child(2) {
          position: relative;
          background: radial-gradient(#e0d7b8 16%, transparent 0),
            radial-gradient(#e0d7b8 16%, transparent 0), #e4dfcc;
          background-position: 0 0, 12px 12px;
          background-size: 24px 24px;
          padding: 24px 32px 120px;
        }
        section:nth-child(2) h2 {
          font-size: 20px;
          margin: 32px auto 16px;
        }
        section:nth-child(2) ul {
          text-align: left;
          text-align: start;
          padding-inline-start: 20px;
          list-style: disc;
          margin: 20px auto;
        }
        .sec-1-img {
          width: 336px;
          height: 216px;
          margin: 48px auto 20px;
          transform: rotate(-2deg);
        }
        .sec-2-img {
          width: 280px;
          height: 182px;
          margin: 20px auto 48px;
          position: relative;
          transform: rotate(2deg) translate(20px, 16px);
        }
        .bf-icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 96px;
          height: 96px;
          background: #f98e62;
          border-radius: 36%;
          box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
          position: absolute;
          top: -16px;
          left: -44px;
          transform: rotate(-6deg);
          z-index: 1;
        }
        /* less than iPhone6/7/8 display size */
        @media screen and (max-width: 374px) {
          .sec-1-img {
            width: 256px;
            height: 166px;
          }
          .sec-2-img {
            width: 208px;
            height: 136px;
          }
          .bf-icon {
            width: 72px;
            height: 72px;
            top: -12px;
            left: -36px;
          }
        }
        /* for iPhone 6/7/8 and iPhone X display size */
        @media screen and (max-width: 399px) and (min-width: 375px) {
          .sec-1-img {
            width: 311px;
            height: 200px;
          }
          .sec-2-img {
            width: 260px;
            height: 169px;
          }
          .bf-icon {
            width: 88px;
            height: 88px;
            top: -14px;
            left: -38px;
          }
        }
      `}
    >
      <section>
        <div className="heading">
          <EmptyFriend />
          <h2>{t('top_empty_no_best_friends')}</h2>
        </div>
        <div className="sec-1-img content">
          <Photo
            srcSet={`
              /images/best-friends/img_bestfriends_tutorial_01-2x.jpg 2x,
              /images/best-friends/img_bestfriends_tutorial_01.jpg 1x
              `}
          />
        </div>
        <p className="content">{t('top_empty_desc_01')}</p>
      </section>
      <section>
        <WaveCover style={{ color: '#f5f1e3' }} />
        <h2 className="content">{t('top_empty_how_to')}</h2>
        <p className="content">{t('top_empty_desc_02')}</p>
        <div className="sec-2-img content">
          <div className="bf-icon">
            <BestFriendIcon width="100%" height="100%" />
          </div>
          <Photo
            srcSet={`
              /images/best-friends/img_bestfriends_tutorial_02-2x.jpg 2x,
              /images/best-friends/img_bestfriends_tutorial_02.jpg 1x
              `}
          />
        </div>
        <p className="content">{t('top_empty_desc_03')}</p>
        <ul className="content">
          <li>{t('top_empty_desc_03_00')}</li>
          <li>{t('top_empty_desc_03_01')}</li>
          <li>{t('top_empty_desc_03_02')}</li>
        </ul>
        <p className="content">{t('top_empty_desc_04')}</p>
      </section>
    </div>
  );
};
